import * as React from 'react';
const SvgWaveThreeDesk = (props: React.SVGAttributes<SVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 1512 232"
    fill="none"
    {...props}
  >
    <g clipPath="url(#tools_bottom_desk_svg__a)">
      <path
        fill="url(#tools_bottom_desk_svg__b)"
        d="M1523.18 176.981c-80.06-18.637-225.49-91.56-384.3-89.46-158.812 2.1-220.499 95.078-377.999 99.54-157.5 4.463-220.5-83.895-378-78.12C225.381 114.716 125.562 262.512 14 225.499-97.563 188.487-533.244 55.969-152.619-68.719 228.006-193.406 1418.44-318.093 1831.88-383.718"
        opacity={0.05}
      />
      <path
        fill="url(#tools_bottom_desk_svg__c)"
        d="M1534.5 160.601c-80.06-18.637-233.19-112.702-392-110.602-158.812 2.1-224 115.038-381.5 119.5-157.5 4.463-220.619-92.793-378.119-87.018C225.381 88.256 111.562 217.012 0 180c-111.562-37.012-533.244-150.49-152.619-275.178 380.625-124.687 1571.059-249.375 1984.499-315"
        opacity={0.37}
      />
      <path
        fill="url(#tools_bottom_desk_svg__d)"
        d="M1523.18 124.061c-80.06-18.637-225.49-91.56-384.3-89.46C980.068 36.701 919 143.537 761.5 148 604 152.462 540.381 50.246 382.881 56.021c-157.5 5.775-266.438 142.853-378 105.84-111.563-37.012-538.125-158.812-157.5-283.5 380.625-124.687 1571.059-249.375 1984.499-315"
        opacity={0.68}
      />
      <path
        fill="url(#tools_bottom_desk_svg__e)"
        d="M1523.59 103.499C1443.53 84.862 1300.22-.703 1141.41 1.397c-158.814 2.1-220.502 115.038-378.002 119.5-157.5 4.463-222.616-91.213-380.116-85.438-157.5 5.775-266.436 142.853-377.999 105.84C-106.269 104.287-487.625-1542.82-107-1667.5c53.087 11.63 193.5 38.5 442.101 28s270.768-54.12 429-55.5c138.972-1.21 288.399 56.5 439.399 56.5 136 0 241.9-73.5 367.9-36.5"
      />
    </g>
    <defs>
      <linearGradient
        id="tools_bottom_desk_svg__b"
        x1={-105140}
        x2={-105140}
        y1={221.104}
        y2={-60262.1}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#006B99" />
        <stop offset={1} stopColor="#3996B3" />
      </linearGradient>
      <linearGradient
        id="tools_bottom_desk_svg__c"
        x1={-105140}
        x2={-105140}
        y1={194.644}
        y2={-60288.6}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#006B99" />
        <stop offset={1} stopColor="#3996B3" />
      </linearGradient>
      <linearGradient
        id="tools_bottom_desk_svg__d"
        x1={-105140}
        x2={-105140}
        y1={168.184}
        y2={-60315}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#006B99" />
        <stop offset={1} stopColor="#3996B3" />
      </linearGradient>
      <linearGradient
        id="tools_bottom_desk_svg__e"
        x1={-105140}
        x2={-105140}
        y1={-748.755}
        y2={-61232}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#006B99" />
        <stop offset={1} stopColor="#3996B3" />
      </linearGradient>
      <clipPath id="tools_bottom_desk_svg__a">
        <path fill="#fff" d="M1512 232H0V0h1512z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgWaveThreeDesk;
